<template>
    <div id="number-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                :placeholder="$t('chatbotv2.number')"
                v-model="item.number.fieldLabel"
                @input="setFieldLabel(item.number.fieldLabel)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: labelAlign === 'left' }" @click="setLabelAlign('left')">{{ $t("form.left") }}</button>
                <button class="button" :class="{ active: labelAlign === 'right' }" @click="setLabelAlign('right')">{{ $t("form.right") }}</button>
                <button class="button" :class="{ active: labelAlign === 'top' }" @click="setLabelAlign('top')">{{ $t("form.top") }}</button>
            </div>
            <!--            <div class="checkbox-group">-->
            <!--                <input type="checkbox" id="default-align" class="checkbox" v-model="defaultAlign">-->
            <!--                <label for="default-align" class="checkbox-label">Varsayılan olarak ayarla</label>-->
            <!--            </div>-->
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.required") }}</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ requiredText }}</span>
            </div>
            <small class="form-description">{{ $t("form.fieldEmptyError") }}</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="alan-slug-degeri"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.subLabels") }}</label>
            <input
                type="text"
                id="sub-label"
                class="form-input"
                :placeholder="$t('form.addDescriptionBelowField')"
                v-model="item.number.subLabel"
                @input="setSubLabel(item.number.subLabel)"
            >
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: 'NumberSettings',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldLabel: this.item.number.fieldLabel,
            labelAlign: this.item.number.labelAlign,
            subLabel: this.item.number.subLabel,
            isRequired: this.item.number.isRequired,
            slug: this.item.slug || '',
            defaultAlign: false,
            updateTimer: null,
        };
    },
    computed: {
        requiredText() {
            return this.isRequired ? this.$t("form.required") : this.$t("form.notRequired");
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setLabelAlign(align) {
            this.labelAlign = align;
            this.$emit('update-label-align-number', align);
            this.updateFields();
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.updateFields();
            this.$emit("update-required", this.isRequired);
        },
        duplicateField() {
            console.log('Field duplicated');
        },
        setFieldLabel(label) {
            this.fieldLabel = label;
           this.$emit("update-field-label-number", label);
            this.updateFields();
        },
        setSubLabel(subLabel) {
            this.subLabel = subLabel;
            this.$emit("update-sub-label-number", subLabel);
            this.updateFields();
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.$emit("update-slug", this.slug);
            this.updateFields();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateFields() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    label: self.fieldLabel,
                    slug: self.slug,
                    number: {
                        fieldLabel: self.fieldLabel,
                        labelAlign: self.labelAlign,
                        subLabel: self.subLabel,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.number) { return; }
                this.fieldLabel = val.number.fieldLabel;
                this.labelAlign = val.number.labelAlign;
                this.subLabel = val.number.subLabel;
                this.isRequired = val.number.isRequired;
                this.slug = val.slug || '';
            },
            deep: true,
            immediate: false,
        },
        'item.number.fieldLabel': function (v) { this.fieldLabel = v; },
        'item.number.labelAlign': function (v) { this.labelAlign = v; },
        'item.number.subLabel': function (v) { this.subLabel = v; },
        'item.number.isRequired': function (v) { this.isRequired = v; },
        'item.slug': function (v) { this.slug = v || ''; },
    },
};
</script>

<style lang="scss" scoped>
#number-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #10b981;
                    color: #ffffff;
                    border-color: #10b981;
                    box-shadow: 0 1px 3px rgba(16, 185, 129, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }
    }
}
</style>
